import React from "react";
import ContactPanel from "./ContactPanel";
import './Experience.css';
import SnhuLogo from '../assets/images/icons/snhu_logo.svg';
import LitesportLogo from '../assets/images/icons/litesport_logo.svg';
import { setSelectedTab } from "../App";
import { Link } from "react-router-dom";

class ExperienceBullet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            descriptionExpanded: props.startWithDescriptionExpanded
        }
    }

    toggleVisibleDescription = (event) => {
        if (event.target.tagName === 'A' || window.getSelection().toString()) {
            return;
        }
        this.setState(state => ({
            descriptionExpanded: !state.descriptionExpanded
          }));
    }

    render() {
        let animateStyles = {};
        let expandLabelStyles = {};
        let descriptionStyles = {};
        if (this.state.descriptionExpanded) {
            animateStyles.maxHeight = '100em';
            expandLabelStyles.opacity = '0';
            descriptionStyles.opacity = '1';
        } else {
            animateStyles.maxHeight = '1.5em';
            expandLabelStyles.opacity = '1';
            descriptionStyles.opacity = '0';
        }

        return (
        <div className="timelineElementMain greyBox">
            <div className="timelineHeader">
                <h3 className="timelineBulletTitle">{this.props.title}</h3>
                <p className="timelineDate">{this.props.date}</p>
            </div>
            <div className="innerBlackBox animateToContentSize" 
            style={animateStyles}
            onClick={(event)=>this.toggleVisibleDescription(event)}>
                <div className="expandLabelText" style={expandLabelStyles}>[ Click to Expand Description ]</div>
                <div className="descriptionText" style={descriptionStyles}>{this.props.description}</div>
            </div>
        </div>
        );
    }
}

class OrgMarker extends React.Component {
    render(){
        return (
        <div className="orgMarker" style={{borderColor: this.props.borderColor}}>
            <table>
                <tbody>
                    <tr>
                        <td valign="top">
                            <img className="timelineOrgImage" src={this.props.image} alt={`${this.props.name} icon`}/>
                        </td>
                        <td valign="top">
                            <h2 className="timelineTitle">{this.props.name}</h2>
                            <p className="timelineDate">{this.props.date}</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            {this.props.content}
        </div>
        );
    }
}

class Experience extends React.Component {
    componentDidMount() {
        setSelectedTab('experience');
    }
    render() {
        return (
        <div className="subpage">
            <Link 
            className='downloadResumeButton'
            to={`https://andrewrollins.info/Andrew_Rollins_Resume.pdf`}
            target='_blank'
            download='Andrew Rollins - Software Engineer.pdf'>
                {'\u2193'} download resume
            </Link>
            <OrgMarker name="Litesport" date={`June 2019 - Present (${timeSinceDate(new Date("06/01/2019"))})`} image={LitesportLogo} borderColor='#027f21' content={
                <div>
                    <ExperienceBullet title='Principal Software Architect' date='August 2022 - Present' description={[
                        <p key={0}>Lead AI/LLM integrations using Gemini and OpenAI APIs.</p>,
                        <p key={1}>Drive cross-platform mobile development across iOS and Android.</p>,
                        <p key={2}>Own architecture for core backend and client-server infrastructure.</p>,
                        <p key={3}>Define technical roadmap for scalable, maintainable systems.</p>,
                        <p key={4}>Lead data modeling, API design, and infrastructure decisions.</p>,
                        <p key={5}>Built and evolved Go-based REST APIs and PostgreSQL schemas.</p>,
                        <p key={6}>Standardized architectural patterns to reduce complexity.</p>,
                        <p key={7}>Serve as code owner for critical repositories.</p>,                     
                    ]}></ExperienceBullet>
        
                    <ExperienceBullet title='Software Engineer' date='June 2019 - August 2022' description={[
                        <p key={0}>Designed reusable input, UI, and API frameworks accelerating development.</p>,
                        <p key={1}>Optimized performance via multithreading, memory tuning, and network redesign.</p>,
                        <p key={2}>Refactored tightly coupled systems into modular architectures.</p>,
                        <p key={3}>Maintained code quality through structured reviews and repo ownership.</p>,
                        <p key={4}>Implemented parallel-build workflows supporting large UX releases.</p>,
                        <p key={5}>Inventor on two software patents; prototyped high-impact systems.</p>,           
                    ]}></ExperienceBullet>
                </div>
            }></OrgMarker>

            <OrgMarker name="Southern New Hampshire University" date="Class of 2021" image={SnhuLogo} borderColor='#00244E' content={
                <ExperienceBullet title='Double Major, Minor - 3.9 GPA' startWithDescriptionExpanded={true} description={
                <section>
                    <h4>Major in Game Programming and Development</h4>
                    <ul>
                        <li>Received the <a href='https://drive.google.com/file/d/1IeuAlGs7BOLWao--khv-PCzgRVkcLZ9t/view?usp=sharing' target="_blank" rel='noreferrer'>Outstanding Student</a> award</li>
                    </ul>
                    <h4>Major in Game Art and Development</h4>
                    <h4>Minor in Applied Mathematics</h4>
                    <p><a href="https://meritpages.com/AndrewRollins" target="_blank" rel='noreferrer'>6 merit-based President List awards</a></p>
                </section>
                }></ExperienceBullet>
            }></OrgMarker>
            <ContactPanel style={{margin: '4em auto 1em', maxWidth: '50em'}}></ContactPanel>
        </div>
        );
    }
}

function timeSinceDate(startDate) {
    let now = new Date();
    let totalMonths = 
        (now.getFullYear() - startDate.getFullYear()) * 12 
        + now.getMonth() - startDate.getMonth();
    
    let months = totalMonths % 12;
    let years = Math.floor(totalMonths / 12);

    let monthString = months > 0 ? `${months} month${months > 1 ? "s" : ""}` : "";
    let yearString = years > 0 ? `${years} year${years > 1 ? "s" : ""}` : "";
    return `${yearString}${yearString !== "" ? ", " : ""}${monthString}`
}

export default Experience;